import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d4121612")

_pushScopeId("data-v-d4121612")
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "kv forseo" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "Contact Us", -1)
const _hoisted_4 = { class: "sec1" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"office-block\" data-v-d4121612><p class=\"title\" data-v-d4121612>EECOMM Office</p><ul class=\"office\" data-v-d4121612><li data-v-d4121612><div class=\"office-item\" data-v-d4121612><div class=\"img img-singapore\" data-v-d4121612></div><div class=\"item-desc-block\" data-v-d4121612><div class=\"item-title\" data-v-d4121612>Singapore Office</div><div class=\"item-desc\" data-v-d4121612> Raffles Place, One Raffles Quay, North Tower #25.00, 25th Floor, Singapore 048583 </div><a href=\"https://goo.gl/maps/8VSxxHXJWZ5NPVtm9\" class=\"gmap\" target=\"_blank\" data-v-d4121612><span data-v-d4121612>Google Maps</span><i data-v-d4121612></i></a></div></div></li><li data-v-d4121612><div class=\"office-item\" data-v-d4121612><div class=\"img img-taiwan\" data-v-d4121612></div><div class=\"item-desc-block\" data-v-d4121612><div class=\"item-title\" data-v-d4121612>Taiwan Office</div><div class=\"item-desc\" data-v-d4121612> Nanjing Technology Building, 9F-3, No. 328, Changchun Road, Zhongshan District, Taipei City, Taiwan 10491 </div><a href=\"https://goo.gl/maps/RJMtUDSN7rJrRgZN9\" class=\"gmap\" target=\"_blank\" data-v-d4121612><span data-v-d4121612>Google Maps</span><i data-v-d4121612></i></a></div></div></li><li data-v-d4121612><div class=\"office-item\" data-v-d4121612><div class=\"img img-indonesia\" data-v-d4121612></div><div class=\"item-desc-block\" data-v-d4121612><div class=\"item-title\" data-v-d4121612>Indonesia Office</div><div class=\"item-desc\" data-v-d4121612> WISMA ANTARA, Level 15, No. 1500, Jl. Medan Merdeka Selatan, Jakarta Pusat, Indonesia 10110. </div><a href=\"https://goo.gl/maps/YBnRUSmMWCQPRbh77\" class=\"gmap\" target=\"_blank\" data-v-d4121612><span data-v-d4121612>Google Maps</span><i data-v-d4121612></i></a></div></div></li><li data-v-d4121612><div class=\"office-item\" data-v-d4121612><div class=\"img img-malaysia\" data-v-d4121612></div><div class=\"item-desc-block\" data-v-d4121612><div class=\"item-title\" data-v-d4121612>Malaysia Office</div><div class=\"item-desc\" data-v-d4121612> Empire Tower, Suite A-5-9, Jalan SS16/1, 47500 Subang Jaya, Selangor Darul Ehsan, Malaysia. </div><a href=\"https://goo.gl/maps/XAHv3LdQBKhKwZkC7\" class=\"gmap\" target=\"_blank\" data-v-d4121612><span data-v-d4121612>Google Maps</span><i data-v-d4121612></i></a></div></div></li></ul></div>", 1)
const _hoisted_6 = { class: "sec2" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "left" }, [
  /*#__PURE__*/_createVNode("p", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Let's Start "),
    /*#__PURE__*/_createVNode("br", { class: "hidden-min" }),
    /*#__PURE__*/_createTextVNode("Your Project With Us")
  ]),
  /*#__PURE__*/_createVNode("p", null, "Please do not hesitate to send us a message.")
], -1)
const _hoisted_9 = { class: "right" }
const _hoisted_10 = {
  key: 0,
  class: "required"
}
const _hoisted_11 = { class: "country" }
const _hoisted_12 = { class: "select" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-d4121612>Country</option><option value=\"Indonesia\" data-v-d4121612>Indonesia</option><option value=\"Singapore\" data-v-d4121612>Singapore</option><option value=\"Taiwan\" data-v-d4121612>Taiwan</option><option value=\"Malaysia\" data-v-d4121612>Malaysia</option>", 5)
const _hoisted_18 = {
  key: 0,
  class: "required"
}
const _hoisted_19 = {
  key: 0,
  class: "required"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("button", { type: "submit" }, "Submit →", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GridLine, { class: "hide2 hide3 hide4 hide5" }),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_GridLine),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      (_ctx.showDialog)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            onClose: _ctx.closeDialog
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_GridLine, { class: "hide4 hide5" }),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("form", {
            action: "",
            autocomplete: "off",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createVNode("div", {
              class: ["full-name", {'is-required': _ctx.validateCount.fullName.value}]
            }, [
              _withDirectives(_createVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullName = $event)),
                placeholder: "*Full Name"
              }, null, 512), [
                [_vModelText, _ctx.fullName]
              ]),
              (_ctx.validateCount.fullName.value)
                ? (_openBlock(), _createBlock("div", _hoisted_10))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.country = $event))
                }, [
                  _hoisted_13
                ], 512), [
                  [_vModelSelect, _ctx.country]
                ])
              ])
            ]),
            _createVNode("div", {
              class: ["email", {'is-required': _ctx.validateCount.eMail.value}]
            }, [
              _withDirectives(_createVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.eMail = $event)),
                placeholder: "*E-mail"
              }, null, 512), [
                [_vModelText, _ctx.eMail]
              ]),
              (_ctx.validateCount.eMail.value)
                ? (_openBlock(), _createBlock("div", _hoisted_18))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode("div", {
              class: ["messages", {'is-required': _ctx.validateCount.messages.value}]
            }, [
              _withDirectives(_createVNode("textarea", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.messages = $event)),
                id: "",
                cols: "30",
                rows: "10",
                placeholder: "*Leave your message..."
              }, null, 512), [
                [_vModelText, _ctx.messages]
              ]),
              (_ctx.validateCount.messages.value)
                ? (_openBlock(), _createBlock("div", _hoisted_19))
                : _createCommentVNode("", true)
            ], 2),
            _hoisted_20
          ], 32)
        ])
      ])
    ])
  ]))
})